import React from 'react'
import Logo from '../Logo/Logo'
import Footer from '../Components/Footer/Footer'
import ContactForm from '../Components/Form/ContactForm'
import styles from './main.module.css'

const Main = () => {
  return (
    <div className='container'>
      <Logo />
      <h1 className={styles.header}><span className={styles.headerAccent}>Заполните форму</span>, чтобы узнать стоимость и сроки списания ваших долгов</h1>
      <ContactForm />
      <Footer />
    </div>
  )
}

export default Main
